import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export var useChangePassword = function () {
    var intl = useIntl();
    var _a = useMutation(function (values) {
        return api.base
            .post('/api/user/changePassword', values)
            .then(function (res) { return res.data; });
    }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { changePassword: mutateAsync, isLoading: isLoading };
};
